//
// Copyright (c) 2025 Quantellia LLC
// All Rights Reserved
//
// import $ from 'jquery';
//import {initializeModelObject} from "./importexport.js";

import {sendSlackMessage, sharedState} from '../../shared.js'

import {initializeModelObject} from "./cddinvis.js";
// import {userSessionIdentifier, sendSlackMessage, DISPLAYERRORSONUSERSCREEN} from "../../shared.js";

export function setCurrentNetworkBeingDisplayed(value) {
  currentNetworkBeingDisplayed = value;
}

export var currentNetworkBeingDisplayed;
var nodeRadius = 20;
// set the size of the arrowheads
var markerWidth = nodeRadius / 2;
var markerHeight = nodeRadius / 2;
//var markerWidth = nodeRadius ;
//var markerHeight = nodeRadius;
const width = 600;
const height = 500;

var simulation;
var graphData;
export var myNetworkOptions;
var draggedNodeId = null;
var draggedNode;
var physicsEnabledBeforeDrag = true;

// Position to place nodes before d.x and d.y are set
const defaultX = 100;
const defaultY = 100;

var newNodes;
var newEdges;


// Global scope, so it can be accessed within createForceDirectedGraph() and updateForceDirectedGraph()
let svg, node, link, text;

let container, containerWidth, containerHeight;

let chatBox, modelMsg, chatId, modelTd, diagramTd, diagramContainer, chatTd, diagram;

let globalNodes, globalEdges;


$(document).ready(function () {
  //modelBox = $("#model-box");
  chatBox = $("#chat-box");
  modelMsg = $("#model-messages");
  chatTd = $("#chat-td");
  modelTd = $("#model-td");
  diagramTd = $("#diagram-td");
  diagram = $("#diagram");
  diagramContainer = $("#diagram-container");

  const openEditModalButton = document.getElementById("open-edit-modal-button");
  const saveNodeChangesButton = document.getElementById("save-node-changes");
  const closeModalButton = document.getElementById("close-modal");
  const nodeEditModalButton = document.getElementById("node-edit-modal-button");

  if (openEditModalButton) {
    openEditModalButton.addEventListener("click", openNodeEditDialogue);
  }

  if (saveNodeChangesButton) {
    saveNodeChangesButton.addEventListener("click", saveNodeChanges);
  }

  if (closeModalButton) {
    closeModalButton.addEventListener("click", closeModal);
  }

  if (nodeEditModalButton) {
    nodeEditModalButton.addEventListener("click", openNodeEditDialogue);
  }
});


export async function CDDRequest(messages) {
  // 0. Find the index.html for the CDD window on the side (astral)
  // 1. Add special code to start the CDD mode if you type a particular phrase (astral)
  // 1. append the CDD request to the message queue -- see old grapher code for how to do this
  // 2. Call sendMessage and await completion so we can be sure that the message queue is up to date
  // 3. Remove any <code> ... </code> tags from the json
  // 4. Attempt to parse the json
  // 5. If it parses successfully, then send it to the CDD window

  sendMessageForNonStreamingResponse(message, true);
}

// Step 1: Remove everything that doesn't appear between <code> and </code> tags
export function processCDDMessage(str) {

  // Convert:
  // '{
  //"nodes":
  // to remove the newline if needed
  // Start by removing leading and trailing whitespace
  str = str.trim();

  // Then, remove newlines from the middle of the string.  This is for saving tokens, and also to match on {"nodes":... in case chatgpt sticks a 
  // newline in there (which it does sometimes)
  str = str.replace(/\n+/g, '');

  // Handle case where there's both ` and <code>...</code>
  str = str.replace(/```<code>/g, '<code>');
  str = str.replace(/<\/code>```/g, '</code>');


  const startTag = '<code>';
  const endTag = '</code>';
  let startIndex, endIndex;
  // DICopilot may have sent back code in multiple forms: delimited by ``...``, by <code>...</code> as we asked, or just with a {"nodes":...} big JSON
  // string in the middle.  Handle all 3 of these cases
  if (str.includes('\`\`\`')) {
    // If chatgpt has used ``...`` to surround the code, then conver those to <code>...</code> tags
    str = str.replace(/```(.*?)```/g, '<code>$1</code>');
  }
  else if (!str.includes(startTag)) {
    if (str.includes('{"nodes":')) {
      // Doesn't have <code>...</code> but does include json. So stick in the code delimeters so we can parse it below 
      startIndex = str.indexOf('{"nodes":'
        // }
      );
      if (startIndex === undefined || startIndex === -1) {
        // If {"nodes": is not found, return the original string. }
        return str;
      }

      //endIndex = findMatchingClosingBracketIndex(str, startIndex + '{"nodes":'.length); //}
      endIndex = findMatchingClosingBracketIndex(str, startIndex); //}

      if (endIndex === undefined || endIndex === -1) {
        // If corresponding closing bracket is not found, return the original string.
        return { codeSnippet: "", textNextToJson: str };
      }
    }

    str = str.slice(0, startIndex) + startTag + str.slice(startIndex, endIndex + 1) + endTag + str.slice(endIndex + 1);
    // } <- for brace matching in editor
    // else {
    //     console.error("CDD message back from GPT is not well-formed: "+ str);
    //     return false;
    //   }
  }

  // START HERE: 
  // BUG HERE: sample code snipped is missing </code>
  var codeStartIndex = str.indexOf(startTag);
  var codeEndIndex = str.indexOf(endTag);

  // Extract what's not between the code tags
  var textNextToJson = str.slice(0, codeStartIndex) + str.slice(codeEndIndex + endTag.length);

  // extract what's between <code> and </code>
  var codeSnippet = str.slice(codeStartIndex + startTag.length, codeEndIndex);

  // Step 2: Removes the <code>...</code> tags
  function removeCodeTags(str) {
    return str.replace(/<\/?code>/gi, '');
  }

  console.log("Returning  codeSnippet: \"" + codeSnippet + "\" and \"" + textNextToJson + "\" from processDICopilotCDDMessage");

  return { "codeSnippet": codeSnippet, "textNextToJson": textNextToJson };
}

// Step 3: Treats the remainder as json that specifies nodes and links in a format that d3.js can understand

// TODO delete I think
// Wait to create the graph until the DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  container = document.getElementById('diagram');
}
);

export function getMyOptions() {
  setUpMyOptions();
  return myNetworkOptions;
}

export function setUpMyOptions() {
  myNetworkOptions = {
    //   configure: {
    //   enabled: true,
    //   filter: 'nodes,edges',
    //   container: undefined,
    //   showButton: true
    // },
    interaction: {
      dragNodes: true // Enable node dragging, even for fixed nodes
    },
    autoResize: true,
    height: '100%',
    width: '100%',
    locale: 'en',
    edges: {
      arrows: 'to',
      color: 'red',
      font: '12px arial #ff0000',
      scaling: {
        label: true,
      },
      shadow: true,
      smooth: true,
    },
    nodes: {
      //  Sets default way to specify labels
      font: {
        multi: "html",
        size: 18,
        boldital: {
          color: "darkblue",
        }
      },
    },
    physics: {
      enabled: true, // Enable physics simulation
      barnesHut: {  // Helps to keep nodes inside the container
        gravitationalConstant: -2000,
        centralGravity: 0.3,
        springLength: 95,
        springConstant: 0.04,
        damping: 0.09,
        avoidOverlap: 0.1 // Helps avoid node overlap
      }
    },
    //   nodes: { // *** Experiment to turn off default node display. But this wrecks all nodes, so I'd have to use my custom renderer on all of them. This could be a workaround if we can't get other mechanisms working
    //   color: {
    //     background: 'transparent', // Set the default node color to transparent
    //   },
    // },
    //manipulation: true,
    manipulation: {
      enabled: true,
      //   addNode: function(nodeData,callback) {
      //    nodeData.label = 'New Element';
      //   callback(nodeData);
      //}
      //  layout: {
      //   hierarchical: {
      //     enabled:false,
      //     levelSeparation: 150,
      //     nodeSpacing: 100,
      //     treeSpacing: 200,
      //     blockShifting: true,
      //     edgeMinimization: true,
      //     parentCentralization: false,
      //     direction: 'RL',        // UD, DU, LR, RL
      //     sortMethod: 'hubsize',  // hubsize, directed
      //     shakeTowards: 'leaves'  // roots, leaves
      //   }
      // }
    }
  }
}

export function setUpInitialCDD(easingType) {
  // nodes = new vis.DataSet([
  //   { id: 1, label: "Node 1" },
  //   { id: 2, label: "Node 2" },
  //   { id: 3, label: "Node 3" },
  //   { id: 4, label: "Node 4" },
  //   { id: 5, label: "Node 5" },
  // ]);

  // edges = new vis.DataSet([
  //   { from: 1, to: 3 },
  //   { from: 1, to: 2 },
  //   { from: 2, to: 4 },
  //   { from: 2, to: 5 },
  // ]);

  globalNodes = new vis.DataSet(hardCodedCDD1.nodes);
  globalEdges = new vis.DataSet(hardCodedCDD1.edges);

  // TODO unnecessary?
  var container = document.getElementById("diagram");

  // TODO make local?
  graphData = {
    nodes: globalNodes,
    edges: globalEdges,
  };
  //var options = {};
  var options = myNetworkOptions;

  currentNetworkBeingDisplayed = new vis.Network(container, graphData, options);
  currentNetworkBeingDisplayed.once("beforeDrawing", function () {
    currentNetworkBeingDisplayed.focus(1, {
      scale: 10,
    });
  });
  currentNetworkBeingDisplayed.once("afterDrawing", function () {
    setUpEventHandlers(currentNetworkBeingDisplayed);
    currentNetworkBeingDisplayed.fit(); // This doesn't seem to be working in this position. but if you say network.fit a bit later, it works.
    // TODO may want to try getting this to work again after we've got physics and node layout working better
    // network.fit({
    //   nodes: nodes.getIds(),
    //   minZoomLevel: 1,
    //   maxZoomLevel: 1,
    //   animation: {
    //     duration: 3000,
    //     easingFunction: easingType,
    //   },
    // });
  });
}

// TODO this is weirdly organized, it includes other functions including 
// initialization of event handlers. It needs to be refactored
export function initializeCDDDiagramSystem() {
  /////
  setUpMyOptions();

  //document.getElementById("easingFunction").selectedIndex = 0;

  // See https://visjs.github.io/vis-network/examples/network/other/onLoadAnimation.html for more information about
  // onLoad easing functions


  /////
  // init
  /////
  // $(document).ready(async function () {
  //   // Wait for the dom to exist so that all of the getCDocumentById calls work
  //   setUpInitialCDD("easeOutQuart");
  // });

  // // create an array with nodes
  // var nodes = new vis.DataSet([
  //   { id: 1, label: "Node 1" },
  //   { id: 2, label: "Node 2" },
  //   { id: 3, label: "Node 3" },
  //   { id: 4, label: "Node 4" },
  //   { id: 5, label: "Node 5" }
  // ]);

  // // create an array with edges
  // var edges = new vis.DataSet([
  //   { from: 1, to: 3 },
  //   { from: 1, to: 2 },
  //   { from: 2, to: 4 },
  //   { from: 2, to: 5 },
  //   { from: 3, to: 3 }
  // ]);

  // // create a network
  // diagramDiv = document.getElementById("diagram");
  // //var diagramContainer = document.getElementById("diagram-container");

  // Add an event listener for the container's onresize event
  window.addEventListener('resize', function () {

    //console.log("Resizing, modelBox width is: "+modelBox.width()+
    // console.log("Resizing, " + "chatBox width is: "+ chatBox.width() +
    //                     ", modelMsg width is: "+ modelMsg.width() +
    //                     ", diagramTd width is: "+ diagramTd.width() +
    //                     ", diagramContainer width is: "+ diagramContainer.width() +
    //                     ", chatTd width is: "+ chatTd.width() +
    //                     ", modelTd width is: "+ modelTd.width() +
    //                     ", window width is: "+ $(window).width() );
  // )

    // Call the fit method to resize the diagram when the container changes size
    if (currentNetworkBeingDisplayed)
      currentNetworkBeingDisplayed.fit();
    else {
      console.error("Can't resize network that doesn't exist yet");
    }
  });

  // old fdg d3-based invocation
  // const input = '<code>{"nodes":[{"id":"A"},{"id":"B"},{"id":"C"}],"links":[{"source":"A","target":"B"},{"source":"B","target":"C"},{"source":"C","target":"A"}]}</code>';
  // let codeSnippet = extractCodeSnippet(input);
  // let jsonStr = removeCodeTags(codeSnippet);
  // let jsonData = parseJson(jsonStr);
  // //if (jsonData) updateForceDirectedGraph(jsonData);
  // if (jsonData) createForceDirectedGraph(jsonData);

}

export async function hideCDDBox() {

  // TODO magic constants
  // TODO this doesn't animate, if you want that to happen then it needs debugging - conflicting CSS rules somewhere?
  diagramTd.removeClass("diagram-td").css({
    width: "75%", // Set the width to the final value before animating
    display: "table-cell" // Make sure the element is visible before animating
  }).hide().animate({
    width: "0%",
  }, {
    duration: 1000,
    complete: function () {
      // After the animation completes, set display to "none"
      diagramTd.css("display", "none");
    }
  });

}
export async function showCDDThinkingAnimation() {
  $("#cddloadanimation").removeClass("hidden");
}

async function hideCDDThinkingAnimation() {
  $("#cddloadanimation").addClass("hidden");
}

// Show the model box with easing effect
export async function showCDDBox() {
  if (!chatBox || !chatTd || !modelTd) {
    console.log("Missing document components while attempting to show model box");
  } else {

    diagramTd.removeClass("hidden").addClass("diagram-td").css({
      width: "0%",
      display: "table-cell" // Set appropriate display value when removing "hidden" class
    }).animate({
      width: "75%",
    }, 1000);

    // // Remove "hidden" class and animate the transition to 75% width
    //       diagramTd.removeClass("hidden").addClass("diagram-td").css("width", "0%").animate({
    //         width: "75%", // Replace with the desired final width percentage
    //       }, 1000); // Set the animation duration (in milliseconds)

    //  diagramTd.removeClass("hidden").addClass("diagram-td"); // Make model box appear, at first very narrow

    // diagramTd.removeClass("hidden").animate({
    //     width: "75%" // This should match the width for diagram-td in the css
    //   }, 1000); // Set the animation duration (in milliseconds)


    // Remove "hidden" class and animate the transition to 75% width
    // diagramTd.removeClass("hidden").animate({
    //   width: "75%" // Replace with the desired final width percentage
    //     }, {
    //       step: function (now, fx) {
    //         // Manually set the width as a percentage during animation
    //         $(this).css("width", now + "%");
    //       },
    //       duration: 5000 // Set the animation duration (in milliseconds)
    //     });

    // Remove "hidden" class and update the width to 75% with a slight delay
    // diagramTd.removeClass("hidden");
    // setTimeout(function () {
    //   diagramTd.css("width", "75%"); // Replace with the desired final width percentage
    // }, 10); // Slight delay to ensure smooth transition


    /*
    // Your jQuery code here, including the $("#chat-td").css() call
    //modelBox.css("visibility", "visible");
    //modelBox.css("display", "table-cell");
    modelBox.css("opacity", 1);

    const chatBoxWidth = chatBox.width();
    const modelBoxWidth = modelBox.width();

    modelTd.removeClass("hidden").addClass("model-td"); // Make model box appear, at first very narrow

    chatTd.css("transition", "width 1.5s ease-in-out"); // Apply transition effect on chat-td width
    modelTd.css("transition", "width 1.5s ease-in-out"); // Apply transition effect on model-td width

    //chatTd.css("width", "0%"); // Set chat-td width to 0% initially

    const finalTDwidthpct = 67;
    const finalmodelwidthpct = 33;
    // const x = finalmodelwidthpct - (modelBoxWidth / chatBoxWidth)*finalTDwidthpct;
    // console.log("Setting chatTD width to: " + finalTDwidthpct + "%")
    // After a short delay, set the widths to desired values
    await setTimeout(() => {
      //chatTd.css("width", `${finalmodelwidthpct - (modelBoxWidth / chatBoxWidth) * finalTDwidthpct}%`);
      chatTd.css("width", finalmodelwidthpct + "%");
      modelTd.css("width", finalTDwidthpct + "%");
    }, 200);
    */

    // Make the basic diagram.  Note this has to be before all the resizing, below,
    // so that the onresize function is called to adjust the diagram to fit the box

  }
}

export function setUpEventHandlers(network) {
  let doubleClickTimeout = null; // Timeout for detecting double-click
  const doubleClickDelay = 250; // Milliseconds between clicks to consider as a double-click

  // when the user uses the vis.js built-in edit menu to add a node, we need to ensure that this node is on
  // the global list of nodes, so it can be found if we edit it or manipulate it later
  network.on("add", function (eventProperties) {
    // TODO this event is never invoked afaik.
    // EventProperties contains information about the added node
    const addedNodeId = eventProperties.nodes[0]; // Assuming only one node is added at a time
    const addedNodeData = network.body.data.nodes.get(addedNodeId); // Get the added node's data

    // Add the addedNodeData to your master list of nodes
    globalNodes.push(addedNodeData);
  });

  // Similar to above for editing nodes; if there's a change, we need to capture it for the globalNodes list
  // TODO what about global edges?  It doesn't look like we do anything independently with that, so I think we're good
  network.on("editNode", function (eventProperties) {
    const editedNodeId = eventProperties.node;
    const editedNodeData = network.body.data.nodes.get(editedNodeId);

    // Update the corresponding node in your master list
    const nodeIndex = globalNodes.findIndex(node => node.id === editedNodeId);
    if (nodeIndex !== -1) {
      globalNodes[nodeIndex] = editedNodeData;
    }
  });

  // Add a click event listener to the network to start the double-click detection
  network.on('click', function (event) {
    if (doubleClickTimeout === null) {
      doubleClickTimeout = setTimeout(() => {
        doubleClickTimeout = null;

        handleSingleClick(event);
      }, doubleClickDelay);
    } else {
      clearTimeout(doubleClickTimeout);
      doubleClickTimeout = null;

      // Double-click action here (e.g., fix node in place)
      const { nodes } = event; // (destructuring syntax: pulls nodes element from event object)

      if (nodes.length > 0) {
        const nodeId = nodes[0];
        //const node = nodes.get(nodeId);
        const node = network.body.nodes[nodeId];

        console.log("double clicked on node with id: " + nodeId);

        if (node.fixed == undefined) node.fixed = true;
        else node.fixed = !node.fixed;

        network.body.data.nodes.update({ id: nodeId, fixed: node.fixed }); // Fix the node in place

        // nodes.update(node); // Update the node in the dataset
        // START HERE getting the node to fix in place
        //nodes.update(node); // Update the node in the DataSet
        //network.setData({ nodes: nodes.get() }); // Update the node options

      }
    }
  });

  // //  var network = new vis.Network(diagramDiv, data, options);
  // network.on('animationfinished', function (event) {
  //   network.fit()  // Ensure that the network fits in the window after it's done moving around
  // });

  // // Add a physics event handler to control the behavior of fixed nodes
  // network.on('physics', function (event) {
  //   const { nodes } = event;
  //   nodes.forEach(nodeId => {
  //     const node = nodes.get(nodeId);
  //     if (node.fixed) {
  //       // If the node is fixed, set its velocity and acceleration to zero
  //       node.vx = 0;
  //       node.vy = 0;
  //       node.ax = 0;
  //       node.ay = 0;
  //     }
  //   });
  // });

  /// 
  // dragging
  // vis.js gives us dragging out of the box, but it doesn't allow when fixed=true. We need to be able to do that so that users can position nodes where
  // they like, so we have to implement our own drag functionality, as shown here
  ///

  // network.on("dragStart", function (params) {
  //   draggedNodeId = params.nodes[0];
  // });


  // network.on("dragStart", function (params) {
  //   draggedNodeId = params.nodes[0];

  //   // Disable physics simulation during the drag if the node is fixed
  //   var node = network.body.nodes[draggedNodeId];
  //   if (node && node.fixed) {
  //     console.log("Dragging a fixed node");
  //     physicsEnabledBeforeDrag = network.physics.physicsEnabled;
  //     if (physicsEnabledBeforeDrag) {
  //       network.setOptions({ physics: { enabled: false } });

  //     }
  //   }
  //   else if (node && !node.fixed)
  //     console.log("Dragging a non-fixed node");
  // });


  //  network.on("dragging", function (params) {
  //   if (draggedNodeId !== null) {
  //     var node = network.body.nodes[draggedNodeId];
  //     if (node) {
  //       var nodeSize = node.options.size;
  //       var canvasX = params.event.clientX - network.canvas.body.container.offsetLeft - nodeSize / 2;
  //       var canvasY = params.event.clientY - network.canvas.body.container.offsetTop - nodeSize / 2;
  //       var canvasPosition = network.DOMtoCanvas({ x: canvasX, y: canvasY });

  //       console.log(`During drag of node id ${draggedNodeId}, canvasposition x is ${canvasPosition.x}, y is ${canvasPosition.y}`);

  //       node.x = canvasPosition.x;
  //       node.y = canvasPosition.y;
  //       network.moveNode(node.id, node.x, node.y);
  //     }
  //   }
  // });


  // network.on("dragging", function (params) {
  //   if (draggedNodeId !== null) {
  //     var node = network.body.nodes[draggedNodeId];
  //     if (node) {
  //       var nodeSize = node.options.size;
  //       var canvasX = params.event.center.x - network.canvas.body.container.offsetLeft - nodeSize / 2;
  //       var canvasY = params.event.center.y - network.canvas.body.container.offsetTop - nodeSize / 2;
  //       var canvasPosition = network.DOMtoCanvas({ x: canvasX, y: canvasY });

  //       node.x = canvasPosition.x;
  //       node.y = canvasPosition.y;

  //       console.log(`During drag of node id ${draggedNodeId}, canvasposition x is ${canvasPosition.x}, y is ${canvasPosition.y}`);

  //       network.moveNode(node.id, node.x, node.y);


  //       // var canvasPosition = network.DOMtoCanvas({
  //       //   x: params.event.center.x,
  //       //   y: params.event.center.y,
  //       // });
  //       // console.log(`During drag of node id ${draggedNodeId}, canvas x is ${canvasPosition.x}, y is ${canvasPosition.y}`);


  //       // var node = network.body.nodes[draggedNodeId];
  //       // if (node) {
  //       //   node.x = canvasPosition.x;
  //       //   node.y = canvasPosition.y;
  //       //   network.moveNode(node.id, node.x, node.y);
  //       // }
  //     }
  //   }
  // });


  // network.on("dragEnd", function () {
  //   draggedNodeId = null;

  //   // Re-enable physics simulation if it was enabled before the drag
  //   if (physicsEnabledBeforeDrag) {
  //     network.setOptions({ physics: { enabled: true } });
  //   }
  // });
  setupFixedNodeDragging(network);
  //setupNodeContextMenu(network);
  makeModalDraggable(network);

}

function setupNodeContextMenu(network) {

  // diagramTd.on("contextmenu", function (params) {
  //   params.preventDefault();
  //   console.log("diagramTd contextmenu clicked");
  // });
  // diagram.on("contextmenu", function (params) {
  //   params.preventDefault();
  //   console.log("diagram contextmenu clicked");
  // });
  // diagramContainer.on("contextmenu", function (params) {
  //   params.preventDefault();
  //   console.log("diagramContainer contextmenu clicked");
  // });
  // $(".vis-network").on("oncontext", function (params) {
  //   params.preventDefault();
  //   console.log("visnetwork oncontext clicked");
  // });

  // diagram.on("click", function (event) {
  //   console.log("diagram clicked");
  //   const nodeId = network.getNodeAt({ x: event.clientX, y: event.clientY });

  //   console.log(nodeId? "Node ID (Click):"+nodeId : "No node clicked" );
  // });

  // diagram.addEventListener("contextmenu", function (event) {
  // diagram.on("contextmenu", function (params) {}


  diagram.on("contextmenu", function (params) {
    params.preventDefault(); // Prevent default context menu

    const pointer = network.DOMtoCanvas({ x: params.clientX, y: params.clientY });
    const nodeId = network.getNodeAt(pointer);

    console.log(nodeId ? "Node ID (Context):" + nodeId : "No node clicked");

    // console.log(`In context menu for diagram, user clicked on position (${params.event.clientX}, ${params.event.clientY})`);
    // console.log(`In context menu for diagram, there are ${params.nodes.length} nodes and ${params.edges.length} edges in the click event`);

  });



  // Right-click event listener on network container
  //diagram.addEventListener("contextmenu", function (event) {}
  // diagram.on("contextmenu", function (event) {}

  //   event.preventDefault();

  //   // Find the node ID if the right-click was performed on a node
  //   const nodeId = network.getNodeAt({ x: event.clientX, y: event.clientY });

  //   console.log(`In context menu for diagram, user clicked on position (${event.clientX}, ${event.clientY})`);

  //   //if (nodeId !== null) 
  //   if (nodeId) {

  //     const node = nodes.get(nodeId);
  //     console.log("User clicked on node with id: "+node.id);

  //     // Show the pop-up editor
  //     const editor = document.getElementById("nodeAttributesEditor");
  //     editor.style.top = `${event.clientY}px`;
  //     editor.style.left = `${event.clientX}px`;
  //     editor.classList.remove("hidden");

  //     // Replace the content of the editor with node attributes
  //     // For example, if you have a "name" attribute in your nodes:
  //     // document.getElementById("nameInput").value = node.name;
  //   } else {
  //     // If right-clicked outside a node, hide the editor
  //     const editor = document.getElementById("nodeAttributesEditor");
  //     editor.classList.add("hidden");
  //   }
  // });

  // // Close the editor when clicking outside it
  // diagram.addEventListener("click", function (event) {
  //   if (!event.target.closest("#nodeAttributesEditor")) {
  //     const editor = document.getElementById("nodeAttributesEditor");
  //     editor.classList.add("hidden");
  //   }
  // });
}

export function setupFixedNodeDragging(network) {

  network.on("dragStart", function (params) {
    draggedNodeId = params.nodes[0];

    // Disable physics simulation during the drag if the node is fixed
    var node = network.body.nodes[draggedNodeId];
    if (node && node.fixed) {
      physicsEnabledBeforeDrag = network.physics.physicsEnabled;
      if (physicsEnabledBeforeDrag) {
        network.setOptions({ physics: { enabled: false } });
      }
    }
  });

  network.on("dragging", function (params) {
    if (draggedNodeId !== null) {
      var node = network.body.nodes[draggedNodeId];
      if (node) {
        var nodeSize = node.options.size;
        // var canvasX = params.event.center.x - network.canvas.body.container.offsetLeft - nodeSize / 2;
        // var canvasY = params.event.center.y - network.canvas.body.container.offsetTop - nodeSize / 2;

        var canvasX = (params.event.center.x - network.canvas.body.container.offsetLeft - nodeSize / 2) / network.getScale();
        var canvasY = (params.event.center.y - network.canvas.body.container.offsetTop - nodeSize / 2) / network.getScale();


        // The following code is to fix a bug where, when was dragging a fixed node, it appeared offset
        // from the cursor
        var scale = network.getScale();

        // Add or subtract an offset value to correct the node position
        // You may need to adjust the offset value based on your specific case
        var yOffset = 0; // Experiment with different values to find the correct offset
        canvasY -= yOffset / scale;
        var xOffset = 0; // Experiment with different values to find the correct offset
        canvasY -= xOffset / scale;

        var canvasPosition = network.DOMtoCanvas({ x: canvasX, y: canvasY });

        node.x = canvasPosition.x;
        node.y = canvasPosition.y;
        network.moveNode(node.id, node.x, node.y);
      }
    }
  });

  network.on("dragEnd", function () {
    draggedNodeId = null;

    // Re-enable physics simulation if it was enabled before the drag
    if (physicsEnabledBeforeDrag) {
      network.setOptions({ physics: { enabled: true } });
    }
  });
}


// // Add a doubleClick event listener to the network so we can fix nodes when they're double clicked
//   network.on('doubleclick', function(event) {
//     const { nodes } = event;
//     if (nodes.length > 0) {
//       const nodeId = nodes[0];
//       const node = nodes.get(nodeId);
//       //node.fixed = !node.fixed; // toggle the node to be fixed or not
//       node.fixed = true; // toggle the node to be fixed or not
//       node.physics = false;
//       nodes.update(node); // Update the node in the DataSet
//     }
//   });

// Simple node label editing on click
export function handleSingleClick(event) {
  var { nodes, edges } = event;

  if (nodes.length === 1) {
    // Show the modal button/icon for the selected node
    showNodeModalButton(nodes[0]);
  }
  else if (nodes.length > 1) {
    // Multiple nodes are selected
    var selectedNodeIds = nodes;
    // Implement your custom handling for batch editing here
    // For example, you could display a message or show a modal for batch editing
    alert("Multiple nodes selected. Batch editing is not supported in this example.");
  } else {
    console.log("No node clicked");
    hideNodeModalButton();
  }

  //   var nodeId = nodes[0];
  //   //var node = network.body.data.nodes.get(nodeId); // Corrected line
  //   var node = network.body.nodes[nodeId];

  //   // Show a prompt to edit the label
  //   // Note this is now handled by "saveNodeChanges()"
  //   var newLabel = prompt("Edit node label:", node.label);

  //   if (newLabel !== null) {

  //     // Per https://stackoverflow.com/questions/57762467/vis-js-network-how-do-i-change-node-label-font-color-dynamically
  //     node.options.label = newLabel;

  //     network.body.emitter.emit('_dataChanged');
  //     network.redraw();

  //   }

}


/// 
// Modal node editor
///

// Function to open the modal with node details
export function openNodeEditDialogue() {
  var nodeId = currentNetworkBeingDisplayed.getSelectedNodes()[0];
  // var node = nodes.get(nodeId);
  var node = currentNetworkBeingDisplayed.body.nodes[nodeId]; // Access the node
  var nameInput = document.getElementById("nameInput");
  //labelInput.value = node.options.label;
  nameInput.value = node.options.elementname;

  var modal = document.getElementById("node-edit-modal");

  var elementTypeInput = document.getElementById("elementTypeSelect");
  elementTypeInput.value = node.options.elementtype;

  modal.style.display = "block";
}

// Function to save changes and update node properties
export function saveNodeChanges() {
  var nodeId = currentNetworkBeingDisplayed.getSelectedNodes()[0];
  if (nodeId !== undefined) {
    var node = currentNetworkBeingDisplayed.body.nodes[nodeId]; // Access the node using network.body.nodes

    // Save the three elements that may change: the node label (based on the name and type), 
    // plus the name and the type (which may have been edited)
    node = saveNodeLabel(node);
    node = saveElementType(node);
    node = saveElementName(node);

    // node.options.label = node.label;          // Not sure why we have to do this

    currentNetworkBeingDisplayed.body.data.nodes.update(node); // Update the node in the DataSet

    currentNetworkBeingDisplayed.body.emitter.emit("_dataChanged"); // Trigger the "_dataChanged" event
    currentNetworkBeingDisplayed.redraw(); // Redraw the network

    currentNetworkBeingDisplayed.body.data.nodes.update(node); // Update the node in the DataSet. Redundant?

    globalNodes = currentNetworkBeingDisplayed.body.data.nodes; // This is a convenience data structure, used for editing
  }
  closeModal();
}

function saveNodeLabel(node) {
  var nameInput = document.getElementById("nameInput");
  //node.options.label = nameInput.value; // This doesn't display, but changes source data
  //node.label = nameInput.value;         // This displays, but doesn't change source data
  node.options.elementname = nameInput.value; // This doesn't display, but changes source data
  node.elementname = nameInput.value; // This displays, but doesn't change source data

  // This changes the node label, based on other fields in the node
  node.options.label = createNodeLabel(node.options).label; // Create the node label
  node.label = node.options.label;
  return node;
}

function saveElementType(node) {
  var elementTypeSelect = document.getElementById("elementTypeSelect");
  //node.options.label = nameInput.value; // This doesn't display, but changes source data
  //node.label = nameInput.value;         // This displays, but doesn't change source data
  node.options.elementtype = elementTypeSelect.value; // This doesn't display, but changes source data
  node.elementtype = elementTypeSelect.value; // This displays, but doesn't change source data. Needed?

  // This changes the node label, based on other fields in the node
  // In this case, we've updated the element type, and that is part of the label, so the
  // label has to change
  node.options.label = createNodeLabel(node.options).label; // Create the node label
  node.label = node.options.label;
  return node;
}

function saveElementName(node) {
  var elementNameField = document.getElementById("nameInput");
  //node.options.label = nameInput.value; // This doesn't display, but changes source data
  //node.label = nameInput.value;         // This displays, but doesn't change source data
  node.options.elementname = elementNameField.value; // This doesn't display, but changes source data
  node.elementname = elementNameField.value; // This displays, but doesn't change source data. Needed?

  // This changes the node label, based on other fields in the node
  // In this case, we've updated the element name, and that is part of the label, so the
  // label has to change
  node.options.label = createNodeLabel(node.options).label; // Create the node label
  node.label = node.options.label;
  return node;
}

function closeModal() {
  // TODO move to a single place so we don't have to repeat this code
  var modal = document.getElementById("node-edit-modal");
  modal.style.display = "none";
  hideNodeModalButton(); // Done editing, so hide the button we used to start it
}

// Function to make the modal draggable
function makeModalDraggable() {
  var modal = document.getElementById("node-edit-modal");
  var isNodeEditorDragging = false;
  var modalOffsetX, modalOffsetY;

  modal.addEventListener("mousedown", function (e) {

    // If the user is dragging to select text in the input field, then don't start the drag
    if (!e.target.matches("#labelInput")) {
      isNodeEditorDragging = true;
      modalOffsetX = e.clientX - modal.getBoundingClientRect().left;
      modalOffsetY = e.clientY - modal.getBoundingClientRect().top;
    }
  });

  document.addEventListener("mousemove", function (e) {
    if (isNodeEditorDragging) {
      modal.style.left = e.clientX - modalOffsetX + "px";
      modal.style.top = e.clientY - modalOffsetY + "px";
    }
  });

  document.addEventListener("mouseup", function () {
    isNodeEditorDragging = false;
  });
}

// Function to show the modal button/icon for the selected node
function showNodeModalButton(nodeId) {

  // TODO use of global nodes could be improved
  //var node = globalNodes.get(nodeId); // Note that this doesn't for nodes added through the editor, because we don't have a way of catching that
  // event and adding the new node to globalNodes. This means that globalNodes won't always be up to date, which is a potential bug creator
  var node = currentNetworkBeingDisplayed.body.data.nodes.get(nodeId); // Get the added node's data
  if (!node) {
    console.error("Can't get node with Id " + nodeId);
    return;
  }
  var modalButton = document.getElementById("node-edit-modal-button");
  if (!node.label) {
    console.error("Can't get node label with Id " + nodeId);
    return;
  }
  //modalButton.innerHTML = `Edit "${node.label}"`;
  modalButton.innerHTML = `Edit "${node.elementname}"`;
  modalButton.style.display = "block";
}

// Function to hide the modal button/icon
export function hideNodeModalButton() {
  var modalButton = document.getElementById("node-edit-modal-button");
  modalButton.style.display = "none";
}

///
// Either display a new CDD or change the existing CDD to the new one as shown in jsonCDD
// TODO easingType is not operational at this time
///
export function displayCDD(easingType, jsonCDD) {

  initializeModelObject(jsonCDD); // Used for export etc. 

  // Sample test data
  // newNodes = new vis.DataSet([
  //   { id: 1, label: "Element 1" },
  //   { id: 2, label: "Element 2" },
  //   { id: 3, label: "Element 3" },
  //   { id: 4, label: "Element 4" },
  //   { id: 5, label: "Element 5" },
  // ]);

  // newEdges = new vis.DataSet([
  //   { from: 1, to: 4 },
  //   { from: 1, to: 5 },
  //   { from: 2, to: 4 },
  //   { from: 3, to: 5 },
  // ]);

  newNodes = jsonCDD["nodes"];
  newEdges = jsonCDD["edges"];

  // TODO unnecessary?
  var container = document.getElementById("diagram");

  // **
  // graphData = {
  //   nodes: nodes,
  //   edges: edges,
  // };

  // animateDataTransition(nodes, edges, newnodes, newedges, easingType);

  // These options don't work, but I'm leaving them in here for future debugging
  const animationOptions = {
    // Configure the animation duration and easing function as desired
    duration: 3000,
    easingFunction: easingType,
    //easingFunction: "easeOutQuart"
  };

  var graphData = {
    nodes: newNodes,
    edges: newEdges
  };

  if (!myNetworkOptions) {
    setUpMyOptions();
  }


  try {

    // Create labels from other node fields
    graphData.nodes = generateCustomLabels(graphData.nodes);

    // If we haven't created a network before, then do so, passing in container and options info as usual
    if (!currentNetworkBeingDisplayed) {
      currentNetworkBeingDisplayed = new vis.Network(container, graphData, myNetworkOptions);
      setUpEventHandlers(currentNetworkBeingDisplayed);
      currentNetworkBeingDisplayed.redraw();
      currentNetworkBeingDisplayed.fit();
    }
    else {
      currentNetworkBeingDisplayed.setData({ graphData, animationOptions });
      currentNetworkBeingDisplayed.redraw();
      currentNetworkBeingDisplayed.fit();
    }
  } catch (err) {
    var phrase = currentNetworkBeingDisplayed ? "setting new data on an existing network" : "creating a new network";
    console.log("Error when " + phrase + ": " + err + ": " + err.stack);
  }

  hideCDDThinkingAnimation();

  // TODO this is ugly to have globals

  // Note that nodes and edges aren't just data, they're also objects with methods
  // created through this constructor
  globalNodes = new vis.DataSet(newNodes);
  globalEdges = new vis.DataSet(newEdges);


  // network = new vis.Network(container, graphData, options);
  // network.once("beforeDrawing", function () {
  //   network.focus(1, {
  //     scale: 10,
  //   });
  // });

  /// TODO this neesd to go into the non-demo CDD code
  // network.on('beforeDrawing', function () {
  //   generateCustomLabels(nodes);
  // });

  currentNetworkBeingDisplayed.once("afterDrawing", function () {
    currentNetworkBeingDisplayed.redraw(); // Show the updated nodes
    currentNetworkBeingDisplayed.fit();
    //   setUpEventHandlers(network);
  });

  // TODO delete this obsolete code
  // TODO this needs to be not just in this function, but elsewhere, too
  // Define special shape for different CDD element types
  // network.on('beforeDrawing', ctx => {

  //   // Clear the old (non-custom) visualization
  //   ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

  //   nodes.forEach(node => {
  //     if (node.elementtype === 'action') {
  //       const position = network.getPositions([node.id])[node.id];
  //       const x = position.x;
  //       const y = position.y;

  //       const radius = 30;

  //       // Clear the canvas for each custom node
  //       ctx.clearRect(x - radius, y - radius, radius * 2, radius * 2);

  //       // Draw the circular node
  //       ctx.beginPath();
  //       ctx.arc(x, y, radius, 0, Math.PI * 2);
  //       ctx.fillStyle = 'lightblue';
  //       ctx.fill();

  //       // Display the label and custom field value above the node
  //       ctx.fillStyle = 'black';
  //       ctx.textAlign = 'center';
  //       ctx.fillText(node.label, x, y + radius + 15); // Label below the circle
  //       ctx.fillText(`Custom: ${node.elementtype}`, x, y - radius - 5); // Custom field above the circle
  //     }
  //   });
  // });


}

//       // Function to animate the transition between old and new data
// function animateDataTransition(initialNodes, initialEdges, newNodes, newEdges, easing) {

//   const animationOptions = {
//     // Configure the animation duration and easing function as desired
//     duration: 3000,
//     easingFunction: easing
//   };

//   const numSteps = 50; // Number of steps for the animation
//   const delayBetweenSteps = animationOptions.duration / numSteps;

//   // Calculate the step-by-step diff for nodes and edges
//   const nodesDiff = newNodes.get({
//     filter: node => initialNodes.get(node.id) === null
//   });
//   const edgesDiff = newEdges.get({
//     filter: edge => initialEdges.get(edge.id) === null
//   });

//   let step = 0;

//   // Animate the transition from initial to new data
//   function doStep() {
//     if (step >= numSteps) {
//       // Animation complete, set the new data
//       network.setData({ nodes: newNodes, edges: newEdges }, animationOptions);
//     } else {
//       const interpolatedNodes = new vis.DataSet();
//       const interpolatedEdges = new vis.DataSet();

//       // Interpolate nodes for the current step
//       for (const nodeDiff of nodesDiff) {
//         const oldNode = initialNodes.get(nodeDiff.id);
//         const interpolatedNode = Object.assign({}, oldNode);
//         interpolatedNode.label = nodeDiff.label;
//         interpolatedNodes.add(interpolatedNode);
//       }

//       // Interpolate edges for the current step
//       for (const edgeDiff of edgesDiff) {
//         const oldEdge = initialEdges.get(edgeDiff.id);
//         const interpolatedEdge = Object.assign({}, oldEdge);
//         interpolatedEdges.add(interpolatedEdge);
//       }

//       // Set the interpolated data for the current step
//       network.setData({ nodes: interpolatedNodes, edges: interpolatedEdges });
//       network.redraw(); // Show the updated nodes

//       step++;
//       setTimeout(doStep, delayBetweenSteps);
//     }
//   }

//   // Start the animation
//   doStep();
// }

export function fitNetwork() {
  currentNetworkBeingDisplayed.fit();
}

export function redrawNetwork() {
  currentNetworkBeingDisplayed.redraw();
}

function findMatchingClosingBracketIndex(str, startIndex) {
  let count = 0;
  for (let i = startIndex; i < str.length; i++) {
    if (str[i] === '{') {
      count++;
    } else if (str[i] === '}') {
      count--;
      if (count === 0) {
        return i;
      }
    }
  }
  return -1; // Corresponding closing bracket not found.
}

// Compose the node label from other fields in the node
function generateCustomLabels(nodes) {
  //const updatedNodes = nodesDataSet.get().map(node => {
  const updatedNodes = nodes.map(node => {
    return createNodeLabel(node)
  });

  //nodesDataSet.update(updatedNodes);
  return updatedNodes;
}

// After receiving a message from DICopilot, parse it into a CDD and display it in the application
export function handleCDDFromDICopilot(chatMessage) {
  console.log("Processing this chatMessage from chatGPT: " + chatMessage);

  if (chatMessage.includes('\`\`\`') || chatMessage.includes('<code>') || chatMessage.includes('{"nodes":')) {
    // Example usage
    //const input = '<code>{"nodes":[{"id":"A"},{"id":"B"},{"id":"C"}],"links":[{"source":"A","target":"B"},{"source":"B","target":"C"},{"source":"C","target":"A"}]}</code>';
    var { codeSnippet, textNextToJson } = processCDDMessage(chatMessage); // TODO what if it returns false?
    if (codeSnippet) {
    const jsonData = parseJson(codeSnippet);

    if (jsonData) {
      displayCDD("easeOutQuart", jsonData, myOptions);
      
      // I'm not doing the following code, which displays the text that comes back from chatGPT.  It often refers
      // to vis.js etc. and we don't want that
      // if (textNextToJson)
      // var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + textNextToJson + '</div></div>';
      // chatBox.append(botMsg);
      // chatBox.scrollTop(chatBox[0].scrollHeight);
    }
  }
    else {
      console.log("Couldn't parse this JSON from chatgpt successfully: " + codeSnippet)
    }
    // TODO add code here to remove all but the most recent CDD from the messages list - not needed and reduces tokens

  }
  // format a non-system message and append it to the chat window
  else {
    formattedChatMessage = chatMessage;
    formattedChatMessage.replace(/\n/g, '<br>'); // Add breaks to make message more readable
    console.error("LLM didn't send us json, it said this instead: " + formattedChatMessage);

    // TODO: need to do the bot send as below in a single function instead of duplicating code
    const noCDDMessage = "I'm sorry but I'm not able to graphically display a new decision model for you at this time.  I'll try again in a little while.";
    var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + noCDDMessage + '</div></div>';
    chatBox.append(botMsg);
    chatBox.scrollTop(chatBox[0].scrollHeight);

    // TODO: test DICopilot again, change the prompt to get more insistent that she create the JSON
    
    // Per the following commented-out text, I don't think we want to hear what DICopilot says about not sending us a CDD.
    // var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + formattedChatMessage + '</div></div>';
    // chatBox.append(botMsg);
    // // Scroll to the bottom of the chat window
    // chatBox.scrollTop(chatBox[0].scrollHeight);
  }

}

// Ask DICopilot to create a CDD based on the conversation so far
async function askDICopilotToCreateCDD() {
  showCDDThinkingAnimation();

  // 1. put the message on the messages queue
  // 2. Send to DICopilot in all-at-once mode
  // 3. parse the response for the CDD
  // 4. display it on the screen
  // Add it to the context

  sharedState.messages.push({ role: "system", content: cddTextFeature.CDDInstructionsForLLM });
  sendSlackMessage(CDDInstructionsForLLM);

  // Trying to get LLM to obey using the following:
  sharedState.messages.push({ role: "user", content: cddTextFeature.userMessagePostCDDInstructions }); // TODO if I look at the messages queue, I don't see this in it
  sendSlackMessage(cddTextFeature.userMessagePostCDDInstructions);
  
  // We don't want to stream the CDD, so use a different mechanism. Also we want the token length to be bigger, and more
  console.log("Waiting for response from DICopilot to CDD request...")
  await sendMessageForNonStreamingResponse( sharedState.messages, 
    { codeInstructionsMessage : true} );
}